export default __webpack_public_path__ + "images/e41e6545.plus_logo_small.png";